import Information from 'components/Information';
import {t} from 'ttag';

const NoResults = ({isFiltered}: {isFiltered: boolean}) => {
    const label = isFiltered
        ? t`No orders matched your search.`
        : t`No documents have been sent yet.`;
    return <Information size="sm">{label}</Information>;
};
export default NoResults;
